const {gql} = require('graphql-tag');
export default gql`
  mutation ($videoID: ID!, $filmID: ID!) {
    makeVimeoFilmMaster(videoID: $videoID, filmID: $filmID) {
      id
      filmID
    }
  }
`;

